import styled, {css} from "styled-components"
import React, {CSSProperties, FC, useState} from "react"

import blueUp from "./image/blueUp.png"
import whiteUp from "./image/whiteUp.png"
import whiteDown from "./image/whiteDown.png"
import blueDown from "./image/blueDown.png"

interface WrapperProps {
    readonly isVerticalLayout: boolean
}

const Wrapper = styled.div<WrapperProps>`
  padding-left: 12px;
  display: flex;
  justify-content: flex-end;
  ${(props) =>
          props.isVerticalLayout &&
          css`
            flex-direction: column;
          `}
`

interface IconBacProps {
    readonly canClick: boolean
}

const IconBac = styled.div<IconBacProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 9px;
  margin-right: 9px;
  border-radius: 42px;

  width: 42px;
  height: 42px;

  background: #ffffff;
  box-shadow: 0px 2px 10px 0px rgba(215, 219, 230, 0.5);

  user-select: none;

  ${(props) =>
          props.canClick &&
          css`
            cursor: pointer;
          `}
`

const Icon = styled.img`
  width: 24px;
  height: 24px;
  -webkit-user-drag: none;
`

export type EvaluationData = {
    praise: boolean
    id?: number
}

type EvaluationProps = {
    style?: CSSProperties
    isVerticalLayout?: boolean
    onEvaluation: (data: EvaluationData) => void
}

export const Evaluation: FC<EvaluationProps> = ({style, onEvaluation, isVerticalLayout = true}) => {
    const [praise, setPraise] = useState<boolean>()

    const notEvaluated = praise === undefined

    const updatePraise = (value: boolean) => {
        if (!notEvaluated) {
            return
        }
        onEvaluation({
            praise: value,
        })
        setPraise(value)
    }

    /**
     *  praise === undefined -> 尚未评价，显示两个白色图标
     *
     *  praise === true -> 显示蓝色向上   // 不可再点击
     *  praise === false -> 显示蓝色向下  // 不可再点击
     */
    return (
        <Wrapper style={style} isVerticalLayout={isVerticalLayout}>
            {(notEvaluated || praise) && (
                <IconBac canClick={notEvaluated} onClick={() => updatePraise(true)}>
                    <Icon src={praise === true ? blueUp : whiteUp}/>
                </IconBac>
            )}

            {(notEvaluated || !praise) && (
                <IconBac canClick={notEvaluated} onClick={() => updatePraise(false)}>
                    <Icon src={praise === false ? blueDown : whiteDown}/>
                </IconBac>
            )}
        </Wrapper>
    )
}
